import { request } from "@/interface/helper";

const str = "inoStation";

export const inoStation = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/ino/station/list" }),
    add: (data) => request({ data, method: "post", url: "/ino/station/add" }),
    detail: (data) => request({ data, method: "post", url: "/ino/station/detail" }),
    edit: (data) => request({ data, method: "post", url: "/ino/station/modify" }),
    clearRule: (data) => request({ data, method: "post", url: "/ino/station/clear" }),
  },
};
